import React from 'react';

import { getEsignatureIntegrations } from '~/common/constants/integrations';
import { useSearchParams } from '~/hooks/router';
import { useIntl } from 'react-intl';

import IntegrationCardList from './IntegrationCardList';

function EsignatureIntegrationCardList() {
  const [_, setTabValue] = useSearchParams('tab'); // eslint-disable-line no-unused-vars
  const intl = useIntl();

  const integrationCards = Object.values(getEsignatureIntegrations()).map(
    (integration) => ({
      ...integration,
      enableStatusDetails: false,
      action: {
        // TODO: we will need to integrate the E-Signature to card design but
        //       for now we just need it functional and show the 3rd party tab
        onClick: () => setTabValue('third-party'),
        text: intl.formatMessage({
          id: 'EsignatureIntegrationCardList.seeIntegration',
          defaultMessage: 'See integration',
          description:
            'Button text to see the E-Signature integration details | maxLength=60',
        }),
      },
    }),
  );

  return <IntegrationCardList integrationCards={integrationCards} />;
}

export default EsignatureIntegrationCardList;
